import { reactive } from 'vue'
import { api, standaloneMode } from './api'
import type { AuthUser } from './types'

export const auth = reactive<{ user: AuthUser | null; ready: boolean }>({ user: null, ready: false })

export function hasCreatorAccess(user = auth.user) {
  const allowed = standaloneMode
    ? ['creator', 'admin', 'safety_admin', 'super_admin']
    : ['admin', 'safety_admin', 'super_admin']
  return Boolean(user && allowed.includes(user.role))
}

export async function refreshAuth() {
  try {
    const result = await api<{ user: AuthUser | null }>('/api/auth/me')
    auth.user = result.user
  } finally {
    auth.ready = true
  }
}

export async function logout() {
  await api('/api/auth/logout', { method: 'POST' })
  auth.user = null
}

export const preferences = reactive({
  sound: localStorage.getItem('lumi-sound') === 'on',
  reducedMotion: localStorage.getItem('lumi-motion') === 'reduced',
})

export function toggleSound() {
  preferences.sound = !preferences.sound
  localStorage.setItem('lumi-sound', preferences.sound ? 'on' : 'off')
}

export function toggleMotion() {
  preferences.reducedMotion = !preferences.reducedMotion
  localStorage.setItem('lumi-motion', preferences.reducedMotion ? 'reduced' : 'full')
  document.documentElement.classList.toggle('reduce-motion', preferences.reducedMotion)
}
